import { i18n } from '@/to-fsd/shared/lib/i18n';

export const clientFileGetFileTypeKey = clientFile => {
  return clientFile.file_type_key;
};

export const getFileTypeLabel = fileType => {
  return i18n.global.t(`entities.clientFile.fileTypeLabel.${fileType}`);
};
